// @ts-nocheck
import './core/polyfill';

import { plugin } from './core/plugin';
import './core/pluginRegister';
import { createHistory } from './core/history';
import { ApplyPluginsType } from '/data1/jenkins/workspace/aplus_tiger_h5_game_details_share_page_202204251659490524a1d2-5835-4a76-a8b1-7acfca817b0e_tiger-platform_gamecenter_h5_game_details_share_page_20220425165949_48687_nodejs_prod/node_modules/@umijs/runtime';
import { renderClient } from '/data1/jenkins/workspace/aplus_tiger_h5_game_details_share_page_202204251659490524a1d2-5835-4a76-a8b1-7acfca817b0e_tiger-platform_gamecenter_h5_game_details_share_page_20220425165949_48687_nodejs_prod/node_modules/@umijs/renderer-react/dist/index.js';
import { getRoutes } from './core/routes';


import '../global.less';
window.HUYA = window.HUYA || {};



const getClientRender = (args: { hot?: boolean; routes?: any[] } = {}) => plugin.applyPlugins({
  key: 'render',
  type: ApplyPluginsType.compose,
  initialValue: () => {
    const opts = plugin.applyPlugins({
      key: 'modifyClientRenderOpts',
      type: ApplyPluginsType.modify,
      initialValue: {
        routes: args.routes || getRoutes(),
        plugin,
        history: createHistory(args.hot),
        isServer: process.env.__IS_SERVER,
        rootElement: 'root',
        defaultTitle: `虎牙游戏`,
      },
    });
    return renderClient(opts);
  },
  args,
});

const clientRender = getClientRender();
export default clientRender();


    window.g_umi = {
      version: '3.5.41',
    };
  

// hot module replacement
// @ts-ignore
if (module.hot) {
  // @ts-ignore
  module.hot.accept('./core/routes', () => {
    const ret = require('./core/routes');
    if (ret.then) {
      ret.then(({ getRoutes }) => {
        getClientRender({ hot: true, routes: getRoutes() })();
      });
    } else {
      getClientRender({ hot: true, routes: ret.getRoutes() })();
    }
  });
}
